import { useQuery } from '@tanstack/react-query';

import { bopsApi } from '@Network';
import useCanAccessAgent from './Agents/useCanAccessAgent';

const useAgents = () => {
  const canAccessAgent = useCanAccessAgent();
  return useQuery({
    queryKey: ['agents'],
    queryFn: () => bopsApi.getAgents(),
    // Skip the fetch entirely when the user can't access agents, so other
    // flavors / users without the access:agent permission never hit the
    // 401/404-prone endpoint.
    enabled: canAccessAgent,
  });
};

export default useAgents;
